import React, { HTMLAttributes, ReactNode, CSSProperties } from 'react';

export type CardProps = Omit<HTMLAttributes<HTMLDivElement>, 'style'> & {
  children?: ReactNode;
  padded?: boolean;
  elevated?: 0 | 1 | 2 | 3;
  style?: CSSProperties;
};

const ELEV = ['none', 'var(--shadow-1)', 'var(--shadow-2)', 'var(--shadow-3)'] as const;

export function Card({
  children,
  padded = true,
  elevated = 0,
  style,
  onClick,
  ...rest
}: CardProps) {
  const elev = ELEV[elevated] || 'none';
  return (
    <div
      onClick={onClick}
      style={{
        background: 'var(--bg-surface)',
        borderRadius: 'var(--r-lg)',
        border: elevated ? 'none' : '1px solid var(--line-divider)',
        boxShadow: elev,
        padding: padded ? 20 : 0,
        transition: 'transform var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out)',
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
